import { useEffect, useRef } from "react";

/**
 * Retain the last non-empty tiles URL across the transient window where a
 * strategy recompute clears the strategyForYear result (any mutation bumps
 * strategyRefreshToken, resetting the query — see api/strategy.ts). Layers
 * keep rendering the retained tiles greyed out instead of going blank, then
 * swap to the fresh URL when the recalculation lands.
 *
 * `isRetained` is true only while showing held-over tiles (a live URL was seen
 * before but the current result has none) — the greyed-out signal.
 */
export const useRetainedTilesUrl = (
  liveUrl: string | undefined
): { tilesUrl: string | undefined; isRetained: boolean } => {
  const lastUrlRef = useRef<string | undefined>(undefined);
  useEffect(() => {
    if (liveUrl) lastUrlRef.current = liveUrl;
  }, [liveUrl]);
  return {
    tilesUrl: liveUrl ?? lastUrlRef.current,
    isRetained: !liveUrl && !!lastUrlRef.current,
  };
};
